import moment from "moment";

type StartOrEndTime = "startTime" | "endTime";

const getMomentFromDate = (d: Date) => moment.utc(`${d.getUTCHours()}:${d.getUTCMinutes()}`, "h:m");

const getMoment = (row: server.dto.TimetableEntry, startOrEnd: StartOrEndTime) => {
  let date = row[startOrEnd];
  const time = date ? getMomentFromDate(new Date(date)) : moment.utc("00:00", "h:m");
  if (row.nextDay) {
    time.add(1, "day");
  }

  return time;
};

const sortTimes = (a: server.dto.TimetableEntry, b: server.dto.TimetableEntry, startOrEnd: StartOrEndTime) => {
  const aMoment = getMoment(a, startOrEnd);
  const bMoment = getMoment(b, startOrEnd);

  return aMoment.valueOf() - bMoment.valueOf();
};

export const sortRows = (a: server.dto.TimetableEntry, b: server.dto.TimetableEntry) => {
  const difference = sortTimes(a, b, "startTime");
  if (difference !== 0) {
    return difference;
  }

  // If start times are equal, check end dates
  return sortTimes(a, b, "endTime");
};
